
export function postData(data ,secLevel) {
    console.log(data)
  try {
    if (typeof eval(Android.encodeData) == "function") {
        return Android.encodeData(data, secLevel);
    } else {
      return "";
    }
  } catch (e) {
    return "";
  }
}

export function getDevice() {
  try {
    if (typeof eval(Android.initData) == "function") {
      return Android.initData()
      
    } else {
      return "";
    }
  } catch (e) {
    return "";
  }
}


// WEBPACK FOOTER //
// ./src/request/android.js